import { jsx as _jsx } from "react/jsx-runtime";
import { CurrentUserProvider } from "@sprout/context/dist/currentUser";
import { BusProvider } from "sprout-ui-dom/dist/Bus";
import { JumpHistoriesProvider } from "@sprout/context/dist/jumpHistories";
import { JumpToProvider } from "@sprout/providers/dist/jumpTo";
import { RouteHistoriesProvider } from "@sprout/providers/dist/routeHistories";
import { GoBackProvider } from "@sprout/providers/dist/goBack";
const GlobalContextProviders = (props)=>{
    const { children , currentUserValue , jumpHistoriesValue  } = props;
    return /*#__PURE__*/ _jsx(RouteHistoriesProvider, {
        children: /*#__PURE__*/ _jsx(CurrentUserProvider, {
            value: currentUserValue,
            children: /*#__PURE__*/ _jsx(JumpHistoriesProvider, {
                value: jumpHistoriesValue,
                children: /*#__PURE__*/ _jsx(BusProvider, {
                    children: /*#__PURE__*/ _jsx(GoBackProvider, {
                        children: /*#__PURE__*/ _jsx(JumpToProvider, {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
export default GlobalContextProviders;
